import { render, staticRenderFns } from "./PainelVisaoEstrategicaUAC.vue?vue&type=template&id=babff2b2"
import script from "./PainelVisaoEstrategicaUAC.vue?vue&type=script&lang=js"
export * from "./PainelVisaoEstrategicaUAC.vue?vue&type=script&lang=js"
import style0 from "./PainelVisaoEstrategicaUAC.vue?vue&type=style&index=0&id=babff2b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports